import React from 'react';
import find from 'lodash/find';

import RelatedTile from '../bundles/RelatedTile';

export function generateRelatedBundlesForAuthors(relatedBundlesByAuthor, authors) {
    let relatedBundlesByAuthorInner = null;

    if (relatedBundlesByAuthor) {
        const authorIds = Object.keys(relatedBundlesByAuthor);
        const bundleElements = [];

        authorIds.forEach(authorId => {
            const bundlesByAuthor = relatedBundlesByAuthor[authorId];
            const author = find(authors, { id: authorId });
            const authorName = `${author.firstName} ${author.lastName}`;

            bundlesByAuthor.forEach(bundle => {
                bundleElements.push(
                    <RelatedTile
                        key={`author-related${bundle.bundleId}`}
                        bundle={bundle}
                        relatedType="authorRelated"
                        title={authorName}
                    />
                );
            });
        });

        relatedBundlesByAuthorInner = <div className="authorBundles">{bundleElements}</div>;
    }
    return relatedBundlesByAuthorInner;
}

export function generateRelatedBundlesForProduct(relatedBundlesByProduct, titleWithoutPrefix) {
    let relatedBundlesByProductInner = null;
    if (relatedBundlesByProduct) {
        const productId = Object.keys(relatedBundlesByProduct)[0];
        const bundleList = relatedBundlesByProduct[productId];

        const bundleElements = bundleList.map(bundle => (
            <RelatedTile
                key={`product-related${bundle.bundleId}`}
                bundle={bundle}
                relatedType="productRelated"
                title={titleWithoutPrefix}
            />
        ));

        relatedBundlesByProductInner = <div className="productBundles">{bundleElements}</div>;
    }
    return relatedBundlesByProductInner;
}
